<template>
    <!-- Page Content Wrapper -->
    <div v-if="permissionsArray.includes('manage_role_permissions')" id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <div class="page-header-top-container">
                <div class="page-name" style="width:100%">{{  page_header }}</div>
            </div>
            <!--page content-->
            <div class="admin-page-content">
                <!--Forms-->
                <div class="forms-container">
                    <div class="row no-margin">
                        <div class="col-6 forms-block">
                            <div class="col-3 paddingleft0">
                                <div class="form-label">Role :</div>
                            </div>
                            <div class="col-9 paddingleft0">
                                <v-select v-model="roleId"
                                          name="roleId"
                                          id="roleId"
                                          label="name"
                                          :filterable="false"
                                          :options="RolesArr"
                                          :clearable=false
                                          @change="roleChange"
                                          placeholder="Select Role">
                                    <template slot="no-options">
                                        Search Location...
                                    </template>
                                    <template slot="option" slot-scope="option">
                                        <div class="d-center">
                                            {{ option.name }}
                                        </div>
                                    </template>
                                    <template slot="selected-option" slot-scope="option">
                                        <div class="selected d-center">
                                            {{ option.name }}
                                        </div>
                                    </template>
                                </v-select>
                                <div class="requiredstar">*</div>
                            </div>
                        </div>
                        <div class="col-6 forms-block">
                            <button type="submit" :disabled="disableButtons.saveButton" class="btn btn-primary nextBtn btn-md pull-left" v-on:click.prevent="createRecord">
                                <i class="hi-icon icon-flSave"> </i> {{buttonNames.saveButton}}
                            </button>
                        </div>
                    </div>
                    <template v-if="PermissionsArr.length > 0">
                        <div class="btm-action-btn-fl row">
                            <div class="col-4 forms-block" v-for="PermissionObj in allPermissions">
                                <div class="pull-left">
                                    <input type="checkbox" :id="PermissionObj.id" :value="PermissionObj.id" v-model="checkedPermissions">
                                </div>
                                <div class="manage-box">
                                    <b-list-group-item for='PermissionObj.id' >{{PermissionObj.name}}</b-list-group-item>
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
                <!-- Forms -->
            </div>
            <!--page content-->
        </div>
        <app-footer></app-footer>
    </div>
    <div v-else>
        <no-permission></no-permission>
    </div>
    <!-- Page Content Wrapper -->
</template>

<script>
    import Vue from 'vue';
    import vSelect from 'vue-select';
    import { Form } from 'bootstrap-vue/es/components';
    import { FormRadio } from 'bootstrap-vue/es/components';
    import Footer from '@/components/partials/Footer';
    import {HTTP} from '../../http-common';
    import {commonMixins} from '../../mixins/commonMixins';
    import EventBus from '.././event-bus';
    import NoAccessPermission from '../NoAccessPermission';
    // import vue2Dropzone from 'vue2-dropzone';
    // import 'vue2-dropzone/dist/vue2Dropzone.min.css';

    /* Vue FlatPickr */
    // import flatPickr from 'vue-flatpickr-component';
    // import 'flatpickr/dist/flatpickr.css';

    /* Bootstrap Data-Picker */
    // import datePicker from 'vue-bootstrap-datetimepicker';
    // import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';
    
    //import tinymce from 'vue-tinymce-editor';
    var self;
    export default {
        name: 'Center',
        mixins: [commonMixins],
        components: {
            'v-select': vSelect,
            'app-footer': Footer,
            "no-permission" : NoAccessPermission,
            // 'vueDropzone': vue2Dropzone,
            // 'tinymce': tinymce,
            //flatPickr,
            // datePicker,
        },
        data() {
            return {
                roleId: {id: '0', name: 'Select Role'},
                RolesArr: [],
                PermissionsArr: [],
                checkedPermissions:[],
                page_header:'Role Permission',
                fields:{
                    name:"",
                    branch:""
                },
                buttonNames : {
                    saveButton : 'Save',
                },
                disableButtons : {
                    saveButton : false,
                },
                allPermissions : [],
                permissionsArray : ['manage_role_permissions'],
            }
        },
        beforeMount: function () {
            self = this;
            EventBus.$emit("menu-selection-changed", "rolePermissionList");
        },
        mounted: function () {
            self.buttonNames.saveButton = 'Update';
            self.getRoleList();
            self.getPermissionList();
            self.getUserPermissions();
        },
        methods: {
            getRoleList() {
                var config = {
                    headers: {
                        Authorization:localStorage.getItem("access_token")
                    },
                };
                // self.RolesArr = [];
                HTTP.get("role", config)
                    .then(function (data) {
                        if (data.status == 200) {
                            if(data.data[0] != 'undefined') {
                                self.roleId = data.data[0];
                            }
                            self.RolesArr= data.data;
                        }
                    })
                    .catch(function (error) {
                        self.catchHandler(error);
                    })
            },
            roleChange(value) {
                //console.log('value', value)
                self.getPermissionListByRoleId(value.id);
            },
            getPermissionListByRoleId(roleId) {
                self.checkedPermissions = [];
                var config = {
                    headers: {
                        Authorization:localStorage.getItem("access_token")
                    },
                };
                if(roleId != 'undefined' && roleId > 0) {
                    HTTP.get("permission/" + roleId + "/byroleid", config)
                    .then(function (data) {
                        if (data.status == 200) {
                            for(var i = 0; i <= data.data.length; i++) {
                                if(typeof(data.data[i]) != 'undefined') {
                                    self.checkedPermissions.push(data.data[i].id);
                                }
                            }
                        }
                    })
                    .catch(function (error) {
                        //console.log('error', error)
                        self.catchHandler(error);
                    })
                }
            },
            getPermissionList() {
                var config = {
                    headers: {Authorization:localStorage.getItem("access_token")},
                };
                HTTP.get("permission", config)
                    .then(function (data) {
                        if (data.status == 200) {
                            self.PermissionsArr = data.data;

                            self.allPermissions = [];
                            for (var i = 0; i < self.PermissionsArr.length; i++) {
                                var permissionNameArray = self.PermissionsArr[i].name.split("_");
                                var permissionName = '';
                                var permission = '';

                                for (var j = 0; j < permissionNameArray.length; j++) {
                                    permission = permissionNameArray[j].charAt(0).toUpperCase() + permissionNameArray[j].slice(1);
                                    permissionName = permissionName +  " " + permission;
                                }
                                self.allPermissions.push({
                                    'id' : self.PermissionsArr[i].id,
                                    'name' : permissionName
                                });
                            }
                        }
                    })
                    .catch(function (error) {
                        self.catchHandler(error);
                    })
            },
            createRecord() {
                self.disableButtons.saveButton = true;
                var id = self.roleId.id;
                var fields = {
                    'id': id,
                    'checkedPermissions': self.checkedPermissions
                }
                // if(!error) {
                HTTP.put("role/"+id+"/permission", fields)
                    .then(function (data) {
                        self.buttonNames.saveButton = "Update";
                        self.disableButtons.saveButton = false;
                        if (data.status == 200) {
                            self.getUserPermissions();
                            self.showSAlert('Permissions updated successfully','success',false);
                        }
                    })
                    .catch(function (error) {
                        self.error_msg_login = "";
                        self.buttonNames.saveButton = "Update";
                        self.disableButtons.saveButton = false;
                        self.catchHandler(error);
                    })
                // }
            },
        }
    };
    EventBus.$on("permissions", function(isLogin, permissionArray) {
        if (typeof self != "undefined") {
            self.permissionsArray = [];
            for (var i = 0; i < permissionArray.length; i++) {
                self.permissionsArray.push(permissionArray[i].name);
            }
        }
    });
</script>


// WEBPACK FOOTER //
// src/components/RolePermission/RolePermission.vue